/* ============================================================
   ATELIER HAÏYA — Animations v2.1
   animations.js

   Gère :
   - Reveal au scroll
   ============================================================ */

   document.addEventListener('DOMContentLoaded', () => {
    initReveal();
  });

  /* ============================================================
     1. REVEAL AU SCROLL
     ============================================================ */

  function initReveal() {
    const elements = document.querySelectorAll('.reveal');
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elements.forEach(el => el.classList.add('reveal--visible'));
      return;
    }

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -48px 0px'
      }
    );

    elements.forEach(el => observer.observe(el));
  }

  /* ============================================================
     EXPORT PUBLIC
     ============================================================ */

  window.AnimationsModule = {
    observeNew: container => {
      if (!container) return;

      const els = container.querySelectorAll('.reveal:not(.reveal--visible)');
      els.forEach((el, i) => {
        setTimeout(() => el.classList.add('reveal--visible'), i * 70);
      });
    }
  };
